import { UserManager } from 'oidc-client-ts';

export const login = async () => {
	// CHECK IDPORTEN LOGIN
	localStorage.setItem("loginRedirect", window.location.href);

	const config = {
		authority: "https://idporten.no",
		client_id: "2983c09a-6c1a-49dc-ac26-1e2bea247fb1",
		redirect_uri: `${location.origin}/callback.html`,
		post_logout_redirect_uri: `${location.origin}/logout-callback.html`,

		response_type: "code",
		scope: "openid profile ks:fiks krr:user/kontaktinformasjon.read", // user/kontaktinformasjon.read",
		loadUserInfo: true,

		// silent renew will get a new access_token via an iframe
		// just prior to the old access_token expiring (60 seconds prior)
		silent_redirect_uri: `${window.location.origin}/silent`,
		automaticSilentRenew: true,

		monitorAnonymousSession: true,

		// will revoke (reference) access tokens at logout time
		revokeAccessTokenOnSignout: true,
	};

	const mgr = new UserManager(config);
	mgr.getUser().then((user) => {
		if (user) {
			// window.user = user;
			if (user.expired) {
				console.log("Token expired");
				mgr.signinRedirect();
				mgr.startSilentRenew();
			}
			mgr.clearStaleState();
			localStorage.setItem("currentLoginState", "LogedIn");
			localStorage.setItem("access_token", user.access_token);
			localStorage.setItem("access_pid", user.profile.pid);
		} else {
			mgr.signinRedirect();
			mgr.startSilentRenew();
		}
	});
};

export const isLogedin = async () => {
	const loginState = localStorage.getItem("currentLoginState");
	// console.log("currentLoginState:", loginState);
	if (loginState === null) {
		return false;
	}
	return loginState === "LogedIn";
};

export const ensureLogedin = async () => {
	const config = {
		authority: "https://idporten.no",
		client_id: "2983c09a-6c1a-49dc-ac26-1e2bea247fb1",
		redirect_uri: `${location.origin}/callback.html`,
		post_logout_redirect_uri: `${location.origin}/logout-callback.html`,

		response_type: "code",
		scope: "openid profile ks:fiks krr:user/kontaktinformasjon.read", // user/kontaktinformasjon.read",
		loadUserInfo: true,

		// silent renew will get a new access_token via an iframe
		// just prior to the old access_token expiring (60 seconds prior)
		silent_redirect_uri: `${window.location.origin}/silent`,
		automaticSilentRenew: true,

		monitorAnonymousSession: true,

		// will revoke (reference) access tokens at logout time
		revokeAccessTokenOnSignout: true,
	};

	const mgr = new UserManager(config);
	return await mgr.getUser().then((user) => {
		if (!user || user.expired) {
			// document.getElementById("userlogin__selector-inner")?.classList.remove("loggedinn");
			localStorage.removeItem("currentLoginState");
			localStorage.removeItem("access_token");
			localStorage.removeItem("access_pid");
			login();
		} else {
			localStorage.setItem("currentLoginState", "LogedIn");
			localStorage.setItem("access_token", user.access_token);
			localStorage.setItem("access_pid", user.profile.pid);
			return user.access_token;
		}
	});
};

export const getAccessToken = () => {
	const config = {
		authority: "https://idporten.no",
		client_id: "2983c09a-6c1a-49dc-ac26-1e2bea247fb1",
		redirect_uri: `${location.origin}/callback.html`,
		post_logout_redirect_uri: `${location.origin}/logout-callback.html`,

		response_type: "code",
		scope: "openid profile ks:fiks krr:user/kontaktinformasjon.read", // user/kontaktinformasjon.read",
		loadUserInfo: true,

		// silent renew will get a new access_token via an iframe
		// just prior to the old access_token expiring (60 seconds prior)
		silent_redirect_uri: `${window.location.origin}/silent`,
		automaticSilentRenew: true,

		monitorAnonymousSession: true,

		// will revoke (reference) access tokens at logout time
		revokeAccessTokenOnSignout: true,
	};

	const mgr = new UserManager(config);
	return mgr.getUser().then((user) => {
		if (!user || user.expired) {
			return user.access_token;
		}
	});
};

export const logout = () => {
	localStorage.setItem("logoutRedirect", location.origin);

	const config = {
		authority: "https://idporten.no",
		client_id: "2983c09a-6c1a-49dc-ac26-1e2bea247fb1",
		redirect_uri: `${location.origin}/callback.html`,
		post_logout_redirect_uri: `${location.origin}/logout-callback.html`,

		response_type: "code",
		scope: "openid profile ks:fiks krr:user/kontaktinformasjon.read", // user/kontaktinformasjon.read",
		loadUserInfo: true,

		// silent renew will get a new access_token via an iframe
		// just prior to the old access_token expiring (60 seconds prior)
		silent_redirect_uri: `${window.location.origin}/silent.html`,
		automaticSilentRenew: true,

		monitorAnonymousSession: true,

		// will revoke (reference) access tokens at logout time
		revokeAccessTokenOnSignout: true,
	};

	const mgr = new UserManager(config);
	if (mgr !== undefined) {
		mgr.signoutRedirect();
		document.getElementById("userlogin__selector-inner")?.classList.remove("loggedinn");
		localStorage.removeItem("currentLoginState");
		localStorage.removeItem("access_token");
		localStorage.removeItem("access_pid");
	}
};
